const Contact = () => import("../components/ContactUs.vue");


/* Exporting the object routes of Contact module. */
export default [
  {
    name: "contact",
    path: "/contact-us",
    meta: {
      Title: "Contact",
      layout: "LoggedLayout",
      requireAuth: true
    },
    component: Contact,
  },
];